"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _deepCompareEquals = _interopRequireDefault(require("../../utils/deepCompareEquals"));
var _useLazyRef = _interopRequireDefault(require("../useLazyRef"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var usePreviousPersistent = function usePreviousPersistent(value, isEqual) {
  var _a, _b;
  if (isEqual === void 0) {
    isEqual = _deepCompareEquals.default;
  }
  var ref = (0, _useLazyRef.default)(function () {
    return {
      value: value,
      prev: value
    };
  });
  var _update = false;
  var current = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.value;
  if (typeof isEqual === 'function') {
    if (!isEqual(value, current)) {
      _update = true;
    }
  } else {
    if (value !== current) {
      _update = true;
    }
  }
  if (_update) {
    ref.current = {
      value: value,
      prev: current
    };
  }
  return (_b = ref.current) === null || _b === void 0 ? void 0 : _b.prev;
};
var _default = usePreviousPersistent;
exports.default = _default;